import { render, staticRenderFns } from "./ClientComment.vue?vue&type=template&id=4c87b7eb&"
import script from "./ClientComment.js?vue&type=script&lang=js&"
export * from "./ClientComment.js?vue&type=script&lang=js&"
import style0 from "./ClientComment.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports